import { Controller } from '@hotwired/stimulus';
import { pausePlayers } from '../../utils/pausePlayers';
/*
 * Description
 * -------
 *
 * Manages Vimeo iframe player.
 *
 * Must be used on iframe element.
 * Can be used multiple times in the document.
 *
 *
 * Values
 * -------
 *
 * - watchTimesPath - (required) - API endpoint to save watch time
 *
 * Usage
 * -------
 *
 * <iframe
 *   src="http://example.com"
 *   data-controller="vimeo-player"
 *   data-vimeo-player-watch-times-path-value="http://example.com"
 * >
 * </iframe>
 */
export class VimeoPlayer extends Controller {
    static values = { watchTimesPath: String };
    async connect() {
        const Vimeo = await import('@vimeo/player');
        const player = new Vimeo.default(this.element, {
            byline: false,
            title: false,
        });
        player.on('play', () => {
            fetch(this.watchTimesPathValue, {
                method: 'POST',
            });
            pausePlayers(this.element);
            this.element.dataset.played = 'true';
        });
    }
}
